import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    // If no language return English
    if (!args) {
      args = 'English';
    }

    // If invalid language return English
    if (this.languages[args] == null) {
      args = 'English';
    }

    let word: string = this.languages[args][value];

    return word ? word : value;
  }

  languages: any = {
    English: {
      purchasing: "Purchasing",
      products: "Products",
      fabric_type: "Fabric Type",
      code: "Code",
      suppliers: "Suppliers",
      collection: "Collection",
      design: "Design",
      colour: "Colour",
      color: "Color",
      supplier_collection: "Supplier Collection",
      supplier_design: "Supplier Design",
      supplier_colour: "Supplier Colour",
      supplier_color: "Supplier Color",
      new: "New",
      delete: "Delete",
      branch: "Branch",
      name: "Name",
      contact: "Contact",
      address: "Address",
      location: "Location",
      phone: "Phone",
      email: "Email",
      po_list: "PO List",
      po: "PO",
      supplier: "Supplier",
      order_date: "Order Date",
      qty_meters: "QTY (Meters)",
      meters: "Meters",
      status: "Status",
      receiving: "Receiving",
      receiving_list: "Receiving List",
      rec: "Rec",
      rec_date: "Rec Date",
      weight_kg: "Weight (kg)",
      inventory: "Inventory",
      inventory_list: "Inventory List",
      pieces: "Pieces",
      available_m: "Available (M)",
      reserved_m: "Reserved (M)",
      missing_m: "Missing (M)",
      ordered_m: "Ordered (M)",
      sales: "Sales",
      order_list: "Order List",
      sales_orders: "Sales Orders",
      list: "List",
      order: "Order",
      invoice: "Invoice",
      client: "Client",
      salesman: "Salesman",
      date: "Date",
      customers: "Customers",
      city: "City",
      accounting: "Accounting",
      branches: "Branches",
      company: "Company",
      pda: "PDA",
      scan: "Scan",
      transfer: "Transfer",
      print_labels: "Print Labels",
      admin: "Admin",
      logout: "Logout",
      home: "Home",
      welcome: "Welcome",
      branch_access: "Branch Access",
      rights: "Rights",
      module_roles: "Module Roles",
      options: "Options",
      create_branch: "Create Branch",
      prefix: "Prefix",
      branch_address: "Branch Address",
      country: "Country",
      currency: "Currency",
      currency_vs_euro: "Currency vs Euro",
      starting_number: "Starting Number",
      invoice_series: "Invoice Series",
      fax: "Fax",
      create: "Create",
      back: "Back",
      you_have_unsaved_changes: "You have unsaved changes",
      no_results_to_display: "No results to display",
      rows_per_page: "Rows per page",
      of: "of",
      supplier_order_ref: "Supplier Order Ref",
      estimate_arrival_date: "Estimate Arrival Date",
      ship_to: "Ship To",
      proforma_invoice_date: "Proforma Invoice date",
      proforma_invoice_number: "Proforma Invoice Number",
      downpayment_amount: "Downpayment Amount",
      downpayment_date: "Downpayment Date",
      final_invoice_number: "Final Invoice Number",
      final_invoice_date: "Final Invoice Date",
      total_amount: "Total amount",
      balance_due_calculated: "Balance due calculated",
      credit_details: "Credit details",
      credit_amount: "Credit amount",
      balance_paid_amount: "Balance paid amount",
      payment_date: "Payment date",
      notes: "Notes",
      fwd_agent_detail: "FWD agent detail",
      closing_date: "Closing date",
      sailing_date: "Sailing date",
      transport_way: "Transport way",
      place_of_dispatch: "Place of dispatch",
      actual_arrival_date: "Actual arrival date",
      collections: "Collections",
      unit_price: "Unit Price",
      total: "Total",
      length: "Length",
      shipping: "Shipping",
      ship_order: "Ship Order",
      all: "All",
      all_branches: "All Branches",
      ship_order_items: "Ship Order Items",
      prepare_order: "Prepare Order",
      notes_capital: "NOTES",
      verify: "Verify",
      scan_skid_location: "Scan skid location",
      ship: "Ship",
      prepare: "Prepare",
      save_preparation_status: "Save Preparation Status",
      sales_order_list: "Sales Order List",
      back_order_list: "Back Order List",
      return_order_list: "Return Order List",
      invoice_list: "Invoice List",
      cheques_list: "Cheques List",
      accounts_management: "Accounts Management",
      locations: "Locations",
      unit_prices: "Unit Prices",
      cities: "Cities",
      import: "Import",
      users: "Users",
      upholstery_fabric: "Upholstery Fabric",
      clothing_fabric: "Clothing Fabric",
      items: "Items",
      total_page: "Total (Page)",
      change_location: "Change Location",
      find_product: "Find Product",
      back_order_: "Back Order ",
      type: "Type",
      processed: "Processed",
      balance: "Balance",
      cheques_: "Cheques ",
      amount: "Amount",
      maturity_date: "Maturity Date",
      find_similar_items: "Find Similar Items",
      list_location_items: "List Location Items",
      cut_item: "Cut Item",
      print_roll_label: "Print Roll Label",
      print_product_label: "Print Product Label",
      print_location_label: "Print Location Label",
      endorsement: "Endorsement",
      deposit: "Deposit",
      bank_id: "Bank ID",
      cash: "Cash",
      local: "Local",
      save_and_print: "Save and Print",
      first_name: "First Name",
      last_name: "Last Name",
      write_level: "Write Level",
      administrator: "Administrator",
      executive: "Executive",
      add: "Add",
      user_login: "User Login",
      user_right: "User Right",
      active: "Active",
      senior: "Senior",
      viewer: "Viewer",
      printer: "Printer",
      position: "Position",
      cpn_code: "CPN Code",
      details: "Details",
      password: "Password",
      country_of_origin: "Country of Origin",
      composition: "Composition",
      choose_image: "Choose Image",
      width: "Width",
      customs_code: "Customs Code",
      picture: "Picture",
      draft: "Draft",
      to_be_completed: "To be completed",
      sumbit_order_to_supplier: "Sumbit order to supplier",
      upload_packing_list_in_receiving: "Upload packing list in Receiving",
      scan_pieces_in_pda_module: "Scan pieces in PDA Module",
      supplier_order_reference_number: "Supplier Order Reference Number",
      additional_details: "Additional Details",
      additional_cost: "Additional Cost",
      payment_: "Payment ",
      advance: "Advance",
      credit: "Credit",
      apply_payment_to: "Apply Payment To",
      final_quantity_produced: "Final Quantity Produced",
      final_invoice_amount: "Final Invoice Amount",
      forward_agent_detail: "Forward Agent Detail",
      print_po: "Print PO",
      undefined_of: "Undefined Of",
      pieces_source_from: "Pieces Source From",
      send_pieces_to: "Send pieces to",
      estimated_delivery_date: "Estimated Delivery Date",
      lot_no: "Lot #",
      search_inventory: "Search Inventory",
      transfer_details: "Transfer Details",
      new_branch_to_branch_transfer_request: "New Branch to Branch Transfer Request",
      transfer_items: "Transfer Items",
      approved: "Approved",
      prepared: "Prepared",
      shipped: "Shipped",
      approve_the_sales_order: "Approve the Sales Order",
      scan_pieces_in_pda_prepare: "Scan Pieces in PDA Prepare",
      scan_pieces_in_pda_shipping: "Scan Pieces in PDA shipping",
      order_details: "Order Details",
      approve_the_back_order: "Approve the Back Order",
      pieces_have_been_ordered: "Pieces have been ordered",
      discount: "Discount",
      shipping_charges: "Shipping Charges",
      sub_total: "Sub Total",
      search_sale_history: "Search Sale History",
      price_sold: "Price Sold",
      register_of_commerce: "Register of Commerce",
      mobile: "Mobile",
      fiscal_id: "Fiscal ID",
      financial_information: "Financial Information",
      term_of_payment: "Term of Payment",
      credit_margin: "Credit Margin",
      share_capital: "Share Capital",
      same_as_above: "Same as above",
      new_payment: "New Payment",
      currency_versus_euro: "Currency Versus Euro",
      sales_tax: "Sales Tax",
      vat_number: "Vat Number",
      starting_date: "Starting Date",
      enter_new_location_and_branch: "Enter New Location and Branch",
      location_name: "Location Name",
      close: "Close",
      enter_new_city_and_country: "Enter new city and country",
      scan_returns: "Scan Returns",
      available_meters: "Available Meters",
      print: "Print",
      update: "Update",
      vat: "VAT",
      add_capital: "ADD",
      order_number: "Order Number",
      order_items: "Order Items",
      page: "Page",
      scan_receiving_number: "Scan Receiving Number",
      piece_number: "Piece Number",
      checking: "Checking",
      piece_no: "Piece No",
      new_account: "New Account",
      starting_balance: "Starting Balance",
      account_details: "Account Details",
      customer: "Customer",
      delivery_date: "Delivery Date",
      customer_po_reference: "Customer PO reference",
      search_here: "Search here",
      receiving_number: "Receiving number",
      new_location: "New location",
      change: "Change",
      product_id: "Product ID",
      find_items: "Find Items",
      new_piece_number: "New Piece Number",
      cut: "Cut",
      invoice_and_payment_details: "Invoice and payment details",
      po_details: "PO Details",
      final_qty_produced: "Final QTY produced",
      shipping_details: "Shipping details",
      save: "Save",
      type_a_name_for_the_account: "Type a name for the account",
      the_type_of_the_account_is_mandatory: "The type of the account is mandatory",
      the_branch_is_mandatory_in_an_account: "The branch is mandatory in an account",
      select_a_currency_for_the_account: "Select a currency for the account",
      invalid_input: "Invalid input",
      account_created_successfully: "Account created successfully",
      could_not_create: "Could not create",
      set_printer: "SET PRINTER",
      update_password: "UPDATE PASSWORD",
      this_collection_will_be_created: "This collection will be created",
      enter_collection_first: "Enter collection first",
      this_design_will_be_created: "This design will be created",
      this_design_exists_as_part_of_another_collectin_is_the_name_correct: "This design exists as part of another collection. Is the name correct",
      weight_gsm: "Weight (GSM)",
      product_detail: "Product Detail",
      supplier_detail: "Supplier Detail",
      design_unit_price: "Design Unit Price",
      save_data: "Save Data",
      all_products: "All products",
      account: "Account",
      contact_name: "Contact name",
      withdrawal: "Withdrawal",
      email_address: "Email Address",
      edit_supplier: "Edit Supplier",
      supplier_product_detail: "Supplier Product Detail",
      po_items: "PO Items",
      finalize_preparation: "Finalize Preparation",
      save_progress: "Save Progress",
      export_this_list: "Export this list",
      sales_report: "Sales Report",
      branch_transfer_report: "Branch Transfer Report",
      requesting_branch: "Requesting Branch",
      ship_from: "Ship from",
      tax: "VAT",
      ship_from_branch: "Ship From Branch",
      edit_catalog: "Edit Catalog",
      catalog: "Catalog",
      catalogs: "Catalogs",
      create_catalog: "Create Catalog",
      required: "Required",
      must_be_unique: "Must Be Unique",
      items_not_shipped: "Items not shipped",
      debit_notes_list: "Debit Notes List",
      debit_notes: "Debit Notes",
      debit: "Debit",
      items_included: "Items Included",
      debit_and_credit_notes: "Debit and Credit Notes",
      debit_and_credit_notes_list: "Debit and Credit Notes List",
      cash_report: "Cash Report",
      report_csv_separator: "Report CSV Separator",
      semicolon_europe: "Semicolon Europe",
      comma_north_america: "Comma North America",
      set_csv_separator: "Set CSV Separator",
      cancel_order: "Cancel Order",
      back_to_reserved: "Back To Reserved",
      all_orders: "All Orders",
      add_piece: "Add Piece",
      send_back_to_preparing: "Send Back To Preparing",
      new_deposit: "New Deposit",
      comission_report: "Comission Report",
      the_date_you_have_selected_is_for_a_different_month_are_you_sure_the_date_is_correct: "the date you have selected is for a different month, are you sure the date is correct?",
      accept: "Accept",
      decline: "Decline",
      packing_list: "Packing List",
      order_confirmation: "Order Confirmation",
      local_invoice: "Local Invoice",
      export_invoice: "Export Invoice",
      sales_forcasting: "Sales Forcasting",
      sales_assistant: "Sales Assistant",
      piece: "Piece",
      commission_report: "Commission Report",
      invoice_number: "Invoice Number",
      multi_select_change_location:"Multi-Select Change Location",
      filtered:"Current", 
      multi_scan:"Multi-Scan",
      input_number:"Input Number",
      moveToTemp:"Move to Temp"           
    },
    Romanian: {
      purchasing: "Aprovizionare",
      products: "Produse",
      fabric_type: "Tip Material",
      code: "Cod",
      suppliers: "Furnizori",
      collection: "Colectie",
      design: "Model",
      colour: "Culoare",
      color: "Culoare",
      supplier_collection: "Colectia Furnizorului",
      supplier_design: "Modelul Furnizorului",
      supplier_colour: "Culoarea Furnizorului",
      supplier_color: "Culoarea Furnizorului",
      new: "Noua",
      delete: "Șterge",
      branch: "Filiala",
      name: "Nume",
      contact: "Date de Contact",
      address: "Adresa",
      location: "Locație",
      phone: "Telefon",
      email: "E-mail",
      po_list: "Lista PO",
      po: "PO",
      supplier: "Furnizor",
      order_date: "Data Comandă",
      qty_meters: "Cantitate (metri)",
      meters: "Metri",
      status: "Stare",
      receiving: "Primire",
      receiving_list: "Lista de Primire",
      rec: "Rec",
      rec_date: "Rec Data",
      weight_kg: "Greutate (kg)",
      inventory: "Inventar",
      inventory_list: "Lista Inventarului",
      pieces: "Bucati",
      available_m: "Disponibil (M)",
      reserved_m: "Rezervat (M)",
      missing_m: "Lipsește (M)",
      ordered_m: "Comandat (M)",
      sales: "Vânzări",
      order_list: "Listă Comenzi",
      sales_orders: "Comenzile de Vânzări",
      list: "Listă",
      order: "Comanda",
      invoice: "Factura fiscala",
      client: "Client",
      salesman: "Vanzator",
      date: "Data",
      customers: "Clienţii",
      city: "Oraș",
      accounting: "Contabilitate",
      branches: "Filiale",
      company: "Companie",
      pda: "PDA",
      scan: "Scaneaza",
      transfer: "Transfer",
      print_labels: "Imprimați Etichete",
      admin: "Admin",
      logout: "Deconectare",
      home: "Acasă",
      welcome: "Bine Ati Venit",
      branch_access: "Accesul la Filială",
      rights: "Drepturile",
      module_roles: "Roluri module",
      options: "Opțiuni",
      create_branch: "Creează Branch",
      prefix: "Prefix",
      branch_address: "Adresa filialei",
      country: "Țară",
      currency: "Valută",
      currency_vs_euro: "Moneda vs Euro",
      starting_number: "Numărul de start",
      invoice_series: "Seria factură",
      fax: "Fax",
      create: "Crea",
      back: "Înapoi",
      you_have_unsaved_changes: "Aveți modificări nesalvate",
      no_results_to_display: "Nu există rezultate pentru a afișa",
      rows_per_page: "Rânduri pe pagină",
      of: "de",
      supplier_order_ref: "Furnizor Comanda Ref",
      estimate_arrival_date: "Estimarea Data sosirii",
      ship_to: "Trimite spre",
      proforma_invoice_date: "Data proforma",
      proforma_invoice_number: "Numărul facturii proforma",
      downpayment_amount: "Suma de avans",
      downpayment_date: "Data downpayment",
      final_invoice_number: "Număr factură finală",
      final_invoice_date: "Final Data facturii",
      total_amount: "Valoare totală",
      balance_due_calculated: "Sold calculata",
      credit_details: "detalii credit",
      credit_amount: "Valoarea creditului",
      balance_paid_amount: "Balanța sumă plătită",
      payment_date: "Data de plată",
      notes: "notițe",
      fwd_agent_detail: "FWD agent detaliu",
      closing_date: "Data limită",
      sailing_date: "Data navigării",
      transport_way: "modalitate de transport",
      place_of_dispatch: "Locul de expediere",
      actual_arrival_date: "Data efectivă de sosire",
      collections: "Colecții",
      unit_price: "Preț unitar",
      total: "Total",
      length: "Lungime",
      shipping: "livrare",
      ship_order: "Comanda Spre Livrare",
      all: "Toate",
      all_branches: "Toate Sucursalele",
      ship_order_items: "Comanda Expedierea Articolelor",
      prepare_order: "Se prepară comandă",
      notes_capital: "NOTE",
      verify: "Verifica",
      scan_skid_location: "locație derapare scanare",
      ship: "Livreaza",
      prepare: "A pregati",
      save_preparation_status: "Stare Salvați Pregătirea",
      sales_order_list: "Listă de vânzări",
      back_order_list: "Înapoi lista de comandă",
      return_order_list: "Retur Vânzări",
      invoice_list: "Listă factură",
      cheques_list: "Listă CEC-uri",
      accounts_management: "Managementul Conturi",
      locations: "locaţii",
      unit_prices: "Unitatea Preturi",
      cities: "Orase",
      import: "Import",
      users: "Utilizatori",
      upholstery_fabric: "Tapițerie Fabric",
      clothing_fabric: "Îmbrăcăminte Fabric",
      items: "Articole",
      total_page: "Total (Pagina)",
      change_location: "Schimbă locația",
      find_product: "Cauta produs",
      back_order_: "Înapoi Comanda",
      type: "Tip",
      processed: "prelucrate",
      balance: "Echilibru",
      cheques_: "CEC-uri",
      amount: "Cantitate",
      maturity_date: "Data scadenței",
      find_similar_items: "Cauta articole similare",
      list_location_items: "Localizare Lista de articole ",
      cut_item: "Cut articol",
      print_roll_label: "Imprimare Etichete Ruloului",
      print_product_label: "Imprimare Eticheta Produsului",
      print_location_label: "Imprimare Eticheta de Locație",
      endorsement: "Aprobare",
      deposit: "Depozit",
      bank_id: "Banca ID",
      cash: "Bani lichizi",
      local: "Local",
      save_and_print: "Salvați și imprimare",
      first_name: "Nume",
      last_name: "Numele de familie",
      write_level: "Nivelul de scriere",
      administrator: "Administrator",
      executive: "Executiv",
      add: "Adăuga",
      user_login: "Logare utilizator",
      user_right: "Dreptul de utilizare",
      active: "Activ",
      senior: "Senior",
      viewer: "telespectator",
      printer: "Imprimanta",
      position: "Poziţie",
      cpn_code: "Codul CPN",
      details: "Detalii",
      password: "Parola",
      country_of_origin: "Tara de origine",
      composition: "Compoziţie",
      choose_image: "Alegeți o imagine",
      width: "Lăţime",
      customs_code: "Codul Vamal",
      picture: "Imagine",
      draft: "Proiect",
      to_be_completed: "Sa fie completat",
      sumbit_order_to_supplier: "Sumbit pentru furnizor",
      upload_packing_list_in_receiving: "Încărcați lista de ambalare în primirea",
      scan_pieces_in_pda_module: "piese de scanare în modulul PDA",
      supplier_order_reference_number: "Furnizor comandă Număr de referință",
      additional_details: "detalii suplimentare",
      additional_cost: "Cost aditional",
      payment_: "Plată",
      advance: "Avans",
      credit: "Credit",
      apply_payment_to: "Aplicare Plata Pentru",
      final_quantity_produced: "Cantitatea finală Produs",
      final_invoice_amount: "Final Sumă facturată",
      forward_agent_detail: "Detalii Forward Agent",
      print_po: "Print PO",
      undefined_of: "nedefinită",
      pieces_source_from: "Piese sursă din",
      send_pieces_to: "Trimite piese la",
      estimated_delivery_date: "Estimată Data de livrare",
      lot_no: "Lot #",
      search_inventory: "Căutare de inventar",
      transfer_details: "Detalii despre transferuri",
      new_branch_to_branch_transfer_request: "Noua sucursala la cerere Branch Transfer",
      transfer_items: "Articole de transfer",
      approved: "Aprobat",
      prepared: "Pregătit",
      shipped: "Trimis",
      approve_the_sales_order: "Aproba comanda de vânzări",
      scan_pieces_in_pda_prepare: "Scanare piese în PDA Pregătiți",
      scan_pieces_in_pda_shipping: "Piese de scanare în PDA de transport maritim",
      order_details: "Comanda Detalii",
      approve_the_back_order: "Aprobați spate Ordinul",
      pieces_have_been_ordered: "Piesele au fost comandate",
      discount: "Reducere",
      shipping_charges: "Taxe de expediere",
      sub_total: "Sub total",
      search_sale_history: "Căutare Vânzare Istoric",
      price_sold: "Preț vândut",
      register_of_commerce: "Registrul Comertului",
      mobile: "Mobil",
      fiscal_id: "ID-ul fiscal",
      financial_information: "Informatie financiara",
      term_of_payment: "Termen de plata",
      credit_margin: "Marja de credit",
      share_capital: "Capitalul social",
      same_as_above: "La fel ca mai sus",
      new_payment: "plată noi",
      currency_versus_euro: "Moneda Euro Versus",
      sales_tax: "Taxa de vanzari",
      vat_number: "TVA",
      starting_date: "Data de inceput",
      enter_new_location_and_branch: "Introdu o locație nouă și Sucursală",
      location_name: "Numele locatiei",
      close: "Închide",
      enter_new_city_and_country: "Introduceți noul oraș și țară",
      scan_returns: "Returnează scanare",
      available_meters: "wattmetre",
      print: "Imprimare",
      update: "Actualizați",
      vat: "VAT",
      add_capital: "ADĂUGA",
      order_number: "Numar de ordine",
      order_items: "Comanda Articole",
      page: "Pagină",
      scan_receiving_number: "Scanare Numărul Primirea",
      piece_number: "Numărul bucata",
      checking: "Cont Curent",
      piece_no: "Numărul bucata",
      new_account: "Cont nou",
      starting_balance: "Sold de pornire",
      account_details: "Detalii cont",
      customer: "Client",
      delivery_date: "Data livrării",
      customer_po_reference: "PO de referință pentru clienți",
      search_here: "Caută aici",
      receiving_number: "Numărul Primirea",
      new_location: "Locație nouă",
      change: "Schimbare",
      product_id: "ID-ul produsului",
      find_items: "Cauta articole",
      new_piece_number: "Număr nou Bucata",
      cut: "A taia",
      invoice_and_payment_details: "Factură și plată detalii",
      po_details: "PO Detalii",
      final_qty_produced: "Cantitatea finală Produs",
      shipping_details: "detalii de expediere",
      save: "Salvați",
      type_a_name_for_the_account: "Tastați un nume pentru cont",
      the_type_of_the_account_is_mandatory: "Tipul contului este obligatoriu",
      the_branch_is_mandatory_in_an_account: "Filiala este obligatorie într-un cont",
      select_a_currency_for_the_account: "Selectați o monedă pentru cont",
      invalid_input: "Intrare nevalidă",
      account_created_successfully: "Contul a fost creat cu succes",
      could_not_create: "Nu s-a putut crea",
      set_printer: "SETAȚI IMPRIMANTA",
      update_password: "ACTUALIZARE PAROLĂ",
      this_collection_will_be_created: "Această colecție va fi creată",
      enter_collection_first: "Introduceți mai întâi de colectare",
      this_design_will_be_created: "Acest design va fi creat",
      this_design_exists_as_part_of_another_collection_is_the_name_correct: "Acest design există ca parte dintr-o altă colecție. Este numele corect",
      weight_gsm: "Greutate (GSM)",
      product_detail: "Detaliile produsului",
      supplier_detail: "Furnizor Detalii",
      design_unit_price: "Proiectare Pret unitar",
      save_data: "Salveaza date",
      all_products: "Toate produsele",
      account: "Cont",
      contact_name: "Nume de contact",
      withdrawal: "Retragere",
      email_address: "Adresa de email",
      edit_supplier: "Editare Furnizor",
      supplier_product_detail: "Detalii furnizor de produse",
      po_items: "PO Articole",
      finalize_preparation: "Finalizati pregatire",
      save_progress: "Salvați progresul",
      export_this_list: "Exportați această listă",
      sales_report: "Raport de vânzări",
      branch_transfer_report: "Sucursala de transfer Raport",
      requesting_branch: "Filiala solicitant",
      ship_from: "Incarca de la",
      tax: "TVA",
      ship_from_branch: "Navă de la Sucursala",
      edit_catalog: "Editare catalog",
      catalog: "Catalog",
      catalogs: "cataloage",
      create_catalog: "Creare catalog",
      required: "Necesar",
      must_be_unique: "Trebuie să fie unic",
      items_not_shipped: "Articole Neexpediată",
      debit_notes_list: "Debit Note Lista",
      debit_notes: "Note de debit",
      debit: "Debit",
      items_included: "Articole incluse",
      debit_and_credit_notes: "Debit și credit",
      debit_and_credit_notes_list: "Listă de debit și credit",
      cash_report: "Raport de numerar",
      report_csv_separator: "Raport CSV Separator",
      semicolon_europe: "Punct și virgulă Europa",
      comma_north_america: "Virgulă America de Nord",
      set_csv_separator: "Set CSV Separator",
      cancel_order: "Anulați comanda",
      back_to_reserved: "Înapoi la rezervate",
      all_orders: "Toate comenzile",
      add_piece: "Adăugați Bucata",
      send_back_to_preparing: "Trimite Înapoi la Pregătirea",
      new_deposit: "Depozit nou",
      comission_report: "Raport comission",
      the_date_you_have_selected_is_for_a_different_month_are_you_sure_the_date_is_correct: "data la care ați selectat este o altă lună sunt sigur că data este corectă",
      accept: "Accept",
      decline: "Declin",
      packing_list: "Lista de impachetat",
      order_confirmation: "Confirmarea comenzii",
      local_invoice: "factură locală",
      export_invoice: "Export factură",
      sales_forcasting: "Previzional Vânzări",
      sales_assistant: "Asistent de vânzări",
      piece: "Bucată",
      commission_report: "Raport al Comisiei",
      invoice_number: "Număr de factură",
      multi_select_change_location:"Schimba Locatia Produselor",
      filtered:"Curent",
      multi_scan:"Scanare Multipla",
      input_number:"Introduceti Seria",
      moveToTemp:"Muta in Temp"       
    },
    Mandarin: {
      purchasing: "购买",
      products: "制品",
      fabric_type: "织物类型",
      code: "码",
      suppliers: "供应商",
      collection: "采集",
      design: "设计",
      colour: "颜色",
      color: "颜色",
      supplier_collection: "供应商收集",
      supplier_design: "供应商设计",
      supplier_colour: "供应商颜色",
      supplier_color: "供应商颜色",
      new: "新",
      delete: "删除",
      branch: "科",
      name: "名称",
      contact: "联系",
      address: "地址",
      location: "地点",
      phone: "电话",
      email: "电子邮件",
      po_list: "PO列表",
      po: "PO",
      supplier: "供应商",
      order_date: "订购日期",
      qty_meters: "数量（米）",
      meters: "米",
      status: "状态",
      receiving: "接收",
      receiving_list: "接收一览表",
      rec: "录音",
      rec_date: "REC DATE",
      weight_kg: "重量（kg）",
      inventory: "库存",
      inventory_list: "库存清单",
      pieces: "件",
      available_m: "可用（M）",
      reserved_m: "版权所有（M）",
      missing_m: "缺少（M）",
      ordered_m: "有序（M）",
      sales: "销售",
      order_list: "订单",
      sales_orders: "销售订单",
      list: "名单",
      order: "订购",
      invoice: "发票",
      client: "客户",
      salesman: "推销员",
      date: "日期",
      customers: "顾客",
      city: "市",
      accounting: "会计",
      branches: "分行",
      company: "公司",
      pda: "PDA",
      scan: "扫描",
      transfer: "传递",
      print_labels: "打印标签",
      admin: "管理员",
      logout: "登出",
      home: "家",
      welcome: "欢迎",
      branch_access: "科访问",
      rights: "权",
      module_roles: "模块角色",
      options: "选项",
      create_branch: "创建分公司",
      prefix: "字首",
      branch_address: "分公司地址",
      country: "国家",
      currency: "货币",
      currency_vs_euro: "货币兑欧元",
      starting_number: "起始号码",
      invoice_series: "发票系列",
      fax: "传真",
      create: "创建",
      back: "背部",
      you_have_unsaved_changes: "您有未保存的更改",
      no_results_to_display: "显示任何结果",
      rows_per_page: "每页的行",
      of: "的",
      supplier_order_ref: "供应商订单参考",
      estimate_arrival_date: "估计到达日期",
      ship_to: "运送到",
      proforma_invoice_date: "形式发票日期",
      proforma_invoice_number: "形式发票号码",
      downpayment_amount: "首付金额",
      downpayment_date: "首期付款日期",
      final_invoice_number: "最终发票号码",
      final_invoice_date: "最终发票日期",
      total_amount: "总金额",
      balance_due_calculated: "尾款计算",
      credit_details: "信用信息",
      credit_amount: "信贷量",
      balance_paid_amount: "余额支付的金额",
      payment_date: "付款日期",
      notes: "笔记",
      fwd_agent_detail: "FWD代理详细",
      closing_date: "截止日期",
      sailing_date: "开航日期",
      transport_way: "运输方式",
      place_of_dispatch: "派遣地点",
      actual_arrival_date: "实际到货日期",
      collections: "集合",
      unit_price: "单价",
      total: "总",
      length: "长度",
      shipping: "运输",
      ship_order: "船舶订单",
      all: "所有",
      all_branches: "所有分支",
      ship_order_items: "船舶订单项目",
      prepare_order: "准备订购",
      verify: "校验",
      scan_skid_location: "扫描防滑位置",
      ship: "船",
      prepare: "准备",
      save_preparation_status: "保存准备状态",
      sales_order_list: "销售订单列表",
      back_order_list: "返回订单清单",
      return_order_list: "返回订单清单",
      invoice_list: "发票清单",
      cheques_list: "检查清单",
      accounts_management: "账户管理",
      locations: "地点",
      unit_prices: "单位价格",
      cities: "城市",
      import: "进口",
      users: "用户",
      upholstery_fabric: "装饰布",
      clothing_fabric: "服装的面料",
      items: "项目",
      total_page: "共（页）",
      change_location: "换地点",
      find_product: "查找产品",
      back_order_: "延期交货",
      type: "类型",
      processed: "处理",
      balance: "平衡",
      cheques_: "检查",
      amount: "量",
      maturity_date: "成人礼",
      find_similar_items: "查找类似项目",
      list_location_items: "列表位置项",
      cut_item: "cut项目",
      print_roll_label: "打印卷筒标签",
      print_product_label: "打印产品标签",
      print_location_label: "打印位置标签",
      endorsement: "背书",
      deposit: "存款",
      bank_id: "银行ID",
      cash: "现金",
      local: "本地",
      save_and_print: "保存并打印",
      first_name: "名字",
      last_name: "姓",
      write_level: "写电平",
      administrator: "管理员",
      executive: "行政人员",
      add: "加",
      user_login: "用户登录",
      user_right: "用户权限",
      active: "活性",
      senior: "前辈",
      viewer: "查看器",
      printer: "打印机",
      position: "位置",
      cpn_code: "CPN代码",
      details: "细节",
      password: "密码",
      country_of_origin: "出生国家",
      composition: "组成",
      choose_image: "选择图片",
      width: "宽度",
      customs_code: "海关代码",
      picture: "图片",
      draft: "草案",
      to_be_completed: "要完成的",
      sumbit_order_to_supplier: "透过以供应商",
      upload_packing_list_in_receiving: "上传在接受装箱单",
      scan_pieces_in_pda_module: "扫描条PDA模块",
      supplier_order_reference_number: "供应商的订单编号",
      additional_details: "额外细节",
      additional_cost: "附加费用",
      payment_: "付款",
      advance: "预先",
      credit: "信用",
      apply_payment_to: "申请支付要",
      final_quantity_produced: "最终大量生产",
      final_invoice_amount: "最终发票金额",
      forward_agent_detail: "正向代理详细",
      print_po: "打印PO",
      undefined_of: "没有定义",
      pieces_source_from: "饮片来源自",
      send_pieces_to: "发件",
      estimated_delivery_date: "预计交货日期",
      lot_no: "批号",
      search_inventory: "搜索库存",
      transfer_details: "汇款细节",
      new_branch_to_branch_transfer_request: "新科分公司传输请求",
      transfer_items: "转让项目",
      approved: "批准",
      prepared: "准备",
      shipped: "运",
      approve_the_sales_order: "批准销售订单",
      scan_pieces_in_pda_prepare: "扫描件在PDA准备",
      scan_pieces_in_pda_shipping: "在PDA发货扫描件",
      order_details: "订单详细信息",
      approve_the_back_order: "核准延期交货",
      pieces_have_been_ordered: "件已经订购",
      discount: "折扣",
      shipping_charges: "运输费用",
      sub_total: "小计",
      search_sale_history: "搜索历史销售",
      price_sold: "价格出售",
      register_of_commerce: "商务部注册",
      mobile: "移动",
      fiscal_id: "财政ID",
      financial_information: "财务信息",
      term_of_payment: "付款条件",
      credit_margin: "信用保证金",
      share_capital: "股本",
      same_as_above: "同上",
      new_payment: "新的支付",
      currency_versus_euro: "货币对战欧元",
      sales_tax: "销售税",
      vat_number: "增值税号码",
      starting_date: "出发日期",
      enter_new_location_and_branch: "进入新位置和新科",
      location_name: "地点名称",
      close: "关",
      enter_new_city_and_country: "进入新的城市和国家",
      scan_returns: "扫描返回",
      available_meters: "可用计",
      print: "打印",
      update: "更新",
      vat: "增值税",
      order_number: "订单号",
      order_items: "订单项目",
      page: "页",
      scan_receiving_number: "扫描接收号码",
      piece_number: "件数",
      checking: "检查",
      piece_no: "一块无",
      new_account: "新账户",
      starting_balance: "期初余额",
      account_details: "帐户详细资料",
      customer: "顾客",
      delivery_date: "邮寄日期",
      customer_po_reference: "客户采购参考",
      search_here: "这里搜索",
      receiving_number: "接收号码",
      new_location: "新位置",
      change: "更改",
      product_id: "产品编号",
      find_items: "查找项目",
      new_piece_number: "新的件数",
      cut: "切",
      invoice_and_payment_details: "发票和付款细节",
      po_details: "PO详情",
      final_qty_produced: "产生最终数量",
      shipping_details: "送货细节",
      save: "保存",
      type_a_name_for_the_account: "为帐户键入一个名称",
      the_type_of_the_account_is_mandatory: "该类型的账户是强制性",
      the_branch_is_mandatory_in_an_account: "该分支是一个账户的强制性",
      select_a_currency_for_the_account: "选择一种货币的帐户",
      invalid_input: "输入无效",
      account_created_successfully: "帐户创建成功",
      could_not_create: "无法创建",
      set_printer: "SET打印机",
      update_password: "更新密码",
      this_collection_will_be_created: "这个系列将被创建",
      enter_collection_first: "首先输入集合",
      this_design_will_be_created: "这种设计将被创建",
      this_design_exists_as_part_of_another_collection_is_the_name_correct: "这种设计存在为另一个集合的一部分。是名称是否正确",
      weight_gsm: "重量（GSM）",
      product_detail: "产品明细",
      supplier_detail: "供应商详细",
      design_unit_price: "设计单位价格",
      save_data: "保存数据",
      all_products: "所有产品",
      account: "帐户",
      contact_name: "联系人姓名",
      withdrawal: "退出",
      email_address: "电子邮件地址",
      edit_supplier: "编辑供应商",
      supplier_product_detail: "供应商产品详细信息",
      po_items: "埔项",
      finalize_preparation: "准备敲定",
      save_progress: "保存进度",
      export_this_list: "导出该列表",
      sales_report: "销售报告",
      branch_transfer_report: "分公司传送报告",
      requesting_branch: "请求科",
      ship_from: "从船舶",
      tax: "税",
      ship_from_branch: "船舶从分公司",
      edit_catalog: "编辑目录",
      catalog: "目录",
      catalogs: "产品目录",
      create_catalog: "创建目录",
      required: "需要",
      must_be_unique: "必须是唯一的",
      items_not_shipped: "项目不发货",
      debit_notes_list: "借记说明问题列表",
      debit_notes: "借记注意事项",
      debit: "借方",
      items_included: "项目包括",
      debit_and_credit_notes: "借记卡和信用票据",
      debit_and_credit_notes_list: "借记卡和信用票据清单",
      cash_report: "现金报告",
      report_csv_separator: "报告CSV分隔符",
      semicolon_europe: "欧洲分号",
      comma_north_america: "逗号北美",
      set_csv_separator: "设置CSV分隔符",
      cancel_order: "取消订单",
      back_to_reserved: "返回保留",
      all_orders: "所有订单",
      add_piece: "添加件",
      send_back_to_preparing: "发送回准备",
      new_deposit: "新的存款",
      comission_report: "Comission报告",
      the_date_you_have_selected_is_for_a_different_month_are_you_sure_the_date_is_correct: "您选择的日期是不同的月份，你确定的日期是正确的",
      accept: "接受",
      decline: "下降",
      packing_list: "打包清单",
      order_confirmation: "订单确认",
      local_invoice: "当地发票",
      export_invoice: "出口发票",
      sales_forcasting: "销售预报中",
      sales_assistant: "销售助理",
      piece: "片",
      commission_report: "委员会报告",
      invoice_number: "发票编号",
    }
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/pipes/translate.pipe.ts